// extracted by mini-css-extract-plugin
export default {"width":"styles_width__+nmR9","preview":"styles_preview__VR7tx","title":"styles_title__vpdMK","container":"styles_container__ZGXHI"};